import { render } from "./NotFoundComponent.vue?vue&type=template&id=7d2a4e06"
const script = {}
script.render = render

export default script